import extendA from './image/extendA.png';
import extend from './image/extend.png';
import { useState } from 'react';

export const ExtendA = ({ extendAAction }: { extendAAction?: () => void }) => {
  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={extendAAction}>
        <img width="18px" height="18px" src={extendA} />
      </div>
    </>
  );
};

export const Extend = ({ extendAction }: { extendAction?: () => void }) => {
  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={extendAction}>
        <img width="18px" height="18px" src={extend} />
      </div>
    </>
  );
};


export const AutoExtend = ({ autoExtendAction }: { autoExtendAction?: (isOpen: boolean) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
    autoExtendAction?.(!isOpen);
  };
  return (
    <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" style={{ backgroundColor: isOpen ? '#E5E5E5' : 'transparent' }} onClick={handleClick}>
      <img width="18px" height="18px" src={extendA} />
    </div>
  );
};